import React from 'react'

import { Button } from '@components/Button'

export const RefreshButton = () => {
  const reloadPage = () => location.reload()

  return (
    <Button className='button' onClick={reloadPage}>
      Refresh
    </Button>
  )
}
